export enum SOFTWARE_HISTORY_HEADERS {
  RUNTIME_VERSION = 'Runtime Version',
  INSTALLED = 'Installed',
}
